/* =========================================================
   SUBSCRIPTION DESCRIPTION FIX
========================================================= */

const ONLINE_DESCRIPTION =
  'Digital-only access to content includes four issues per year, renewing annually.';

const PRINT_DESCRIPTION =
  'Shipped to US, includes four issues per calendar year and access to online content, renewing annually.';

const ONLINE_TWO_YEAR_DESCRIPTION =
  'Digital-only access to content includes four issues per year, renewing every two years.';

const PRINT_TWO_YEAR_DESCRIPTION =
  'Shipped to US, includes four issues per calendar year and access to online content, renewing every two years.';


/* =========================================================
   HELPERS
========================================================= */

function isOnlineSubscription(value) {
  const text = String(value || '').trim().toLowerCase();

  return (
    text === 'digital' ||
    text === 'online' ||
    text.includes('digital') ||
    text.includes('online')
  );
}

function isTwoYearSubscription(value) {
  return /\b(?:2|two)[\s-]*years?\b|\b24[\s-]*months?\b/i.test(
    String(value || '')
  );
}

function getSubscriptionDescription(type, duration) {
  if (isTwoYearSubscription(duration)) {
    return isOnlineSubscription(type)
      ? ONLINE_TWO_YEAR_DESCRIPTION
      : PRINT_TWO_YEAR_DESCRIPTION;
  }

  return isOnlineSubscription(type)
    ? ONLINE_DESCRIPTION
    : PRINT_DESCRIPTION;
}


/* =========================================================
   1. APPSTLE BUNDLE PRODUCT
========================================================= */

function initAppstleBundleDescriptions() {

  function updateBundleDescription() {
    const selects = document.querySelectorAll(
      '.ab-bogo-variant-select, #ab-bogo-variant-dropdown'
    );

    selects.forEach(function (select) {

      // Make sure this is the subscription bundle dropdown
      const hasOnlineOption = Array.from(select.options).some(function (option) {
        return isOnlineSubscription(option.textContent);
      });

      if (!hasOnlineOption) return;

      const selectedText =
        select.options[select.selectedIndex]?.textContent?.trim() || '';

      const descriptionText = getSubscriptionDescription(
        selectedText,
        selectedText
      );

      let description = select.parentElement.querySelector(
        '.custom-plan-description'
      );

      if (!description) {
        description = document.createElement('div');
        description.className = 'custom-plan-description';

        description.style.cssText = `
          margin-top: 8px;
          font-size: 13px;
          line-height: 1.5;
        `;

        select.insertAdjacentElement(
          'afterend',
          description
        );
      }

      if (description.textContent !== descriptionText) {
        description.textContent = descriptionText;
      }
    });
  }


  /* Wait for Appstle Bundle widget */

  let attempts = 0;

  const bundleWait = setInterval(function () {
    attempts++;

    const bundleSelect = document.querySelector(
      '.ab-bogo-variant-select, #ab-bogo-variant-dropdown'
    );

    if (bundleSelect) {
      clearInterval(bundleWait);
      updateBundleDescription();
    }

    // Stop after around 15 seconds
    if (attempts >= 50) {
      clearInterval(bundleWait);
    }
  }, 300);


  /* Bundle dropdown change */

  document.addEventListener('change', function (e) {

    if (
      e.target.matches(
        '.ab-bogo-variant-select, #ab-bogo-variant-dropdown'
      )
    ) {
      setTimeout(function () {
        updateBundleDescription();
      }, 200);
    }

  });
}


/* =========================================================
   2. NORMAL SUBSCRIPTION PDP
   DIGITAL / US / CDN / FOREIGN
========================================================= */

function initProductOptionDescriptions() {

  const typeSelect = document.querySelector(
    'select[name="option1"].option-selector'
  );

  // Do not apply subscription wording to unrelated merchandise options.
  if (!typeSelect || !Array.from(typeSelect.options).some(function (option) {
    return isOnlineSubscription(option.textContent);
  })) return;

  function updateSellingPlanDescription(value) {
    const descriptions = document.querySelectorAll(
      '.appstleSellingPlanDescription'
    );

    if (!descriptions.length) return false;

    descriptions.forEach(function (description) {
      const planContainer = description.closest('.appstle_subscribe_option');
      const planSelect = planContainer?.querySelector('select.appstle_select');
      const selectedPlan = planSelect?.options[planSelect.selectedIndex];

      // Customer-facing wording only: do not change the selling plan ID,
      // prices, payment frequency or Appstle's underlying configuration.
      if (selectedPlan?.value === '2695757933') {
        const planLabel = '2 Year Subscription';
        if (selectedPlan.textContent !== planLabel) {
          selectedPlan.textContent = planLabel;
        }
        const singleOptionText = planContainer.querySelector(
          '.appstle_single_option_text'
        );
        if (singleOptionText && singleOptionText.textContent !== planLabel) {
          singleOptionText.textContent = planLabel;
        }
      }

      const planText = planSelect?.options[planSelect.selectedIndex]?.textContent;
      const duration = getCurrentOptionValue('option2') || planText || value;
      const descriptionText = getSubscriptionDescription(value, duration);

      // Preserve Appstle's element, attributes and styling. Only update text
      // when necessary, including after an asynchronous widget redraw.
      if (description.textContent !== descriptionText) {
        description.textContent = descriptionText;
      }
    });

    return true;
  }


  /* Get current Type option */

  function getCurrentOptionValue(optionName) {

    const optionSelect = document.querySelector(
      'select[name="' + optionName + '"].option-selector'
    );

    if (!optionSelect) return null;

    const picker = optionSelect.closest(
      'barracuda-variant-picker'
    );

    const selectedSwatch = picker?.querySelector(
      '.options-frame.flex-wrap.blocks.small .swatch.selected'
    );

    if (selectedSwatch) {
      return selectedSwatch.getAttribute('value');
    }

    return optionSelect.value;
  }

  function getCurrentTypeValue() {
    return getCurrentOptionValue('option1');
  }

  function scheduleDescriptionUpdate() {
    [200, 500].forEach(function (delay) {
      setTimeout(function () {
        const value = getCurrentTypeValue();
        if (value) updateSellingPlanDescription(value);
      }, delay);
    });
  }


  /* Initial description after Appstle loads */

  let attempts = 0;

  const descriptionWait = setInterval(function () {
    attempts++;

    const value = getCurrentTypeValue();

    if (value && updateSellingPlanDescription(value)) {
      clearInterval(descriptionWait);
    }

    // Stop after around 15 seconds
    if (attempts >= 50) {
      clearInterval(descriptionWait);
    }

  }, 300);


  /* Handle both subscription type and 1 Year / 2 Year clicks. */

  document.addEventListener('click', function (e) {

    const swatch = e.target.closest(
      '.options-frame.flex-wrap.blocks.small .swatch'
    );

    if (!swatch) return;


    const picker = swatch.closest(
      'barracuda-variant-picker'
    );

    if (!picker) return;


    if (!picker.querySelector('select.option-selector')) return;

    scheduleDescriptionUpdate();

  });

  document.addEventListener('change', function (e) {
    if (e.target.matches(
      'select.option-selector, select.appstle_select, [name="selling_plan"], [name="id"]'
    )) {
      scheduleDescriptionUpdate();
    }
  });

  const productRoot = typeSelect.closest('[id^="product-detail-"]');
  if (productRoot && typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function () {
      const value = getCurrentTypeValue();
      if (value) updateSellingPlanDescription(value);
    });
    observer.observe(productRoot, { childList: true, subtree: true });
  }
}


/* =========================================================
   INIT
========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  // PDP only
  if (!window.location.pathname.includes('/products/')) {
    return;
  }

  // Bundle products
  initAppstleBundleDescriptions();

  // Normal subscription products
  initProductOptionDescriptions();

});
